import React from 'react';

import type { SVGProps } from 'react';

export type IconProps = {
  // Due to inconsistency of icon paths, color default value has been removed.
  // If an icon has multiple paths, use className to pick a path to paint.
  color?: string;
  size?: number | string;
} & SVGProps<SVGSVGElement>;

const getDisplayName = (WrappedComponent: any) =>
  WrappedComponent.displayName || WrappedComponent.name || 'Component';

function withIconProps(
  WrappedComponent: any,
  options: {
    // for some icons which is not a square, we don't want to put a default size like 24x24.
    // we can either turn off shouldSetDefaultSize to not change the icon's size, or set
    // defaultWidth and defaultHeight manually to overwrite the size
    shouldSetDefaultSize?: boolean;
    defaultWidth?: number;
    defaultHeight?: number;
  } = {
    shouldSetDefaultSize: true,
    defaultWidth: 24,
    defaultHeight: 24,
  },
) {
  function NewComponent(props: IconProps) {
    const { size, color, className, ...rest } = props;

    const style = {
      height: props.size,
      width: props.size,
    };

    if (options.shouldSetDefaultSize) {
      style.height = style.height || options.defaultHeight;
      style.width = style.width || options.defaultWidth;
    }

    return <WrappedComponent {...rest} className={className} color={color} style={style} />;
  }

  NewComponent.displayName = `withIconProps(${getDisplayName(WrappedComponent)})`;

  NewComponent.defaultProps = {
    color: 'currentColor',
  };

  return NewComponent;
}

export default withIconProps;
